/* GOSS persistent vehicle — Rivian-gearshop-style "remember my truck".
   Stores the customer's selected truck in localStorage, shows a header chip,
   and renders a fit badge on product pages by matching product tags. */
(function () {
  var KEY = 'goss:vehicle';
  var EVT = 'goss:vehicle:changed';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      return v && v.make && v.model ? v : null;
    } catch (e) {
      return null;
    }
  }

  function write(vehicle) {
    try {
      if (vehicle) localStorage.setItem(KEY, JSON.stringify(vehicle));
      else localStorage.removeItem(KEY);
    } catch (e) { /* private mode */ }
    document.dispatchEvent(new CustomEvent(EVT, { detail: read() }));
  }

  window.GossVehicle = {
    get: read,
    set: function (v) { write(v); },
    clear: function () { write(null); },
    label: function () {
      var v = read();
      if (!v) return '';
      return (v.year ? v.year + ' ' : '') + v.make + ' ' + v.model;
    }
  };

  /* ---------- Fitment map (keep in sync with homepage hero blocks) ---------- */
  var FITMENT = [
    { make: 'Kenworth', model: 'T680 Next Gen', yearFrom: 2022, yearTo: 0, url: '/collections/kw-t680-next-gen' },
    { make: 'Kenworth', model: 'T680 Legacy', yearFrom: 2012, yearTo: 2021, url: '/collections/kw-t680-legacy' },
    { make: 'Kenworth', model: 'T880', yearFrom: 2014, yearTo: 0, url: '/collections/kw-t880' },
    { make: 'Kenworth', model: 'T480', yearFrom: 2021, yearTo: 0, url: '/collections/kw-t480' },
    { make: 'Freightliner', model: 'Cascadia P3', yearFrom: 2008, yearTo: 2017, url: '/collections/freightliner-cascadia-p3' },
    { make: 'Freightliner', model: 'Cascadia P4', yearFrom: 2018, yearTo: 2025, url: '/collections/freightliner-cascadia-p4' },
    { make: 'Freightliner', model: 'Cascadia 5th Gen', yearFrom: 2025, yearTo: 0, url: '/collections/freightliner-cascadia-5th-gen' },
    { make: 'International', model: 'LT', yearFrom: 2017, yearTo: 0, url: '/collections/international-lt' },
    { make: 'DAF', model: 'XF', yearFrom: 2013, yearTo: 0, url: '/collections/daf-xf' },
    { make: 'Peterbilt', model: '579', yearFrom: 2013, yearTo: 0, url: '/collections/peterbilt-579' }
  ];
  var NOW_YEAR = new Date().getFullYear();
  FITMENT.forEach(function (v) { if (!v.yearTo) v.yearTo = NOW_YEAR; });

  /* ---------- Fit-your-vehicle modal (Rivian style) ---------- */
  var modalEl = null;

  function buildModal() {
    if (modalEl) return modalEl;
    modalEl = document.createElement('div');
    modalEl.className = 'goss-fitmodal';
    modalEl.hidden = true;
    modalEl.innerHTML =
      '<div class="goss-fitmodal__overlay" data-fitmodal-close></div>' +
      '<div class="goss-fitmodal__dialog" role="dialog" aria-modal="true" aria-label="Select your vehicle">' +
      '<button type="button" class="goss-fitmodal__close" data-fitmodal-close aria-label="Close">&times;</button>' +
      '<h2 class="goss-fitmodal__title">Select your vehicle</h2>' +
      '<p class="goss-fitmodal__sub">We\u2019ll show you the parts engineered to fit it exactly.</p>' +
      '<form class="goss-fitmodal__form">' +
      '<label>Year<select data-fm-year required><option value="">Select year</option></select></label>' +
      '<label>Make<select data-fm-make required disabled><option value="">Select make</option></select></label>' +
      '<label>Model<select data-fm-model required disabled><option value="">Select model</option></select></label>' +
      '<button type="submit" class="goss-fitmodal__submit" disabled>Find my parts</button>' +
      '</form></div>';
    document.body.appendChild(modalEl);

    var yearEl = modalEl.querySelector('[data-fm-year]');
    var makeEl = modalEl.querySelector('[data-fm-make]');
    var modelEl = modalEl.querySelector('[data-fm-model]');
    var submitEl = modalEl.querySelector('.goss-fitmodal__submit');
    var form = modalEl.querySelector('form');

    function setOptions(sel, vals, ph) {
      sel.innerHTML = '';
      var o = document.createElement('option');
      o.value = ''; o.textContent = ph; sel.appendChild(o);
      vals.forEach(function (v) {
        var x = document.createElement('option');
        x.value = v; x.textContent = v; sel.appendChild(x);
      });
    }
    function matches(v, y, m) {
      if (y && (y < v.yearFrom || y > v.yearTo)) return false;
      if (m && v.make !== m) return false;
      return true;
    }
    function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }

    var minY = Math.min.apply(null, FITMENT.map(function (v) { return v.yearFrom; }));
    var maxY = Math.max.apply(null, FITMENT.map(function (v) { return v.yearTo; }));
    var years = []; for (var y = maxY; y >= minY; y--) years.push(y);
    setOptions(yearEl, years, 'Select year');

    yearEl.addEventListener('change', function () {
      var y = parseInt(yearEl.value, 10) || null;
      makeEl.disabled = !y; modelEl.disabled = true; submitEl.disabled = true;
      setOptions(modelEl, [], 'Select model');
      if (!y) { setOptions(makeEl, [], 'Select make'); return; }
      setOptions(makeEl, uniq(FITMENT.filter(function (v) { return matches(v, y, null); }).map(function (v) { return v.make; })).sort(), 'Select make');
    });
    makeEl.addEventListener('change', function () {
      var y = parseInt(yearEl.value, 10) || null;
      var m = makeEl.value || null;
      modelEl.disabled = !m; submitEl.disabled = true;
      if (!m) { setOptions(modelEl, [], 'Select model'); return; }
      setOptions(modelEl, uniq(FITMENT.filter(function (v) { return matches(v, y, m); }).map(function (v) { return v.model; })).sort(), 'Select model');
    });
    modelEl.addEventListener('change', function () { submitEl.disabled = !modelEl.value; });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var y = parseInt(yearEl.value, 10) || null;
      var match = FITMENT.find(function (v) {
        return v.make === makeEl.value && v.model === modelEl.value && matches(v, y, makeEl.value);
      });
      if (!match) return;
      write({ year: y, make: match.make, model: match.model, url: match.url });
      closeModal();
      window.location.href = match.url;
    });

    // Delegated: any click on a close control (or a near-miss inside its padding) closes
    modalEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-fitmodal-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    modalEl._prefill = function () {
      var v = read();
      if (!v || !v.year) return;
      yearEl.value = String(v.year);
      yearEl.dispatchEvent(new Event('change'));
      if (v.make) {
        makeEl.value = v.make;
        makeEl.dispatchEvent(new Event('change'));
        if (v.model) {
          modelEl.value = v.model;
          modelEl.dispatchEvent(new Event('change'));
        }
      }
    };
    return modalEl;
  }

  function openModal() {
    buildModal();
    modalEl._prefill();
    modalEl.hidden = false;
    document.documentElement.classList.add('goss-fitmodal-open');
    var first = modalEl.querySelector('[data-fm-year]');
    if (first) first.focus();
  }
  function closeModal() {
    if (!modalEl) return;
    modalEl.hidden = true;
    document.documentElement.classList.remove('goss-fitmodal-open');
  }
  window.GossVehicle.openModal = openModal;

  /* ---------- Header chip ---------- */
  function renderChip() {
    var mount = document.querySelector('[data-goss-vehicle-chip]');
    if (!mount) return;
    var v = read();
    var CAR_ICON = '<svg class="goss-chip__icon" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M1 15h3m0 0a3 3 0 1 0 6 0m-6 0V6a1 1 0 0 1 1-1h9v10m0 0h2m-2 0a3 3 0 1 0 6 0m0 0h2v-5l-3-4h-5"/></svg>';
    mount.hidden = false;
    if (!v) {
      mount.innerHTML =
        '<button type="button" class="goss-chip goss-chip--cta" aria-haspopup="dialog">' + CAR_ICON +
        '<span class="goss-chip__label">Fit your vehicle</span></button>';
      mount.querySelector('.goss-chip').addEventListener('click', openModal);
      return;
    }
    mount.innerHTML =
      '<button type="button" class="goss-chip" aria-haspopup="dialog" aria-label="Change your truck (currently ' +
      (v.make + ' ' + v.model).replace(/"/g, '&quot;') + ')">' + CAR_ICON +
      '<span class="goss-chip__label">' + window.GossVehicle.label() + '</span>' +
      '</button>' +
      '<button type="button" class="goss-chip__clear" aria-label="Clear my truck">&times;</button>';
    mount.querySelector('.goss-chip').addEventListener('click', openModal);
    mount.querySelector('.goss-chip__clear').addEventListener('click', function () {
      window.GossVehicle.clear();
    });
  }

  /* ---------- Product page fit badge ---------- */
  function renderFitBadge() {
    var el = document.querySelector('[data-goss-fit]');
    if (!el) return;
    var v = read();
    var tags = (el.getAttribute('data-product-tags') || '').toLowerCase();
    if (!v) {
      el.innerHTML =
        '<span class="goss-fit goss-fit--neutral">Not sure it fits? ' +
        '<a href="/#VehicleSelectorForm">Select your truck</a></span>';
      return;
    }
    var modelMatch = tags.indexOf(v.model.toLowerCase()) !== -1;
    var makeMatch = tags.indexOf(v.make.toLowerCase()) !== -1;
    if (modelMatch) {
      el.innerHTML =
        '<span class="goss-fit goss-fit--yes">&#10003; Fits your ' + window.GossVehicle.label() + '</span>';
    } else if (makeMatch) {
      el.innerHTML =
        '<span class="goss-fit goss-fit--warn">&#9888; Made for a different ' + v.make +
        ' model &mdash; you drive a ' + v.model + '</span>';
    } else {
      el.innerHTML =
        '<span class="goss-fit goss-fit--warn">&#9888; Not listed for your ' + window.GossVehicle.label() +
        ' &mdash; <a href="' + encodeURI(v.url || '/') + '">see parts that fit</a></span>';
    }
  }

  /* ---------- Collection page vehicle banner ---------- */
  function renderCollectionBanner() {
    var el = document.querySelector('[data-goss-collection-banner]');
    if (!el) return;
    var v = read();
    if (!v) { el.hidden = true; el.innerHTML = ''; return; }
    var here = decodeURIComponent(location.pathname);
    var mine = decodeURIComponent((v.url || '').split('?')[0]);
    el.hidden = false;
    if (mine && here === mine) {
      el.innerHTML =
        '<div class="goss-cbanner"><span class="goss-cbanner__text">' +
        'Showing parts for your <strong>' + window.GossVehicle.label() + '</strong></span>' +
        '<button type="button" class="goss-cbanner__clear">Clear vehicle <span aria-hidden="true">&times;</span></button></div>';
      el.querySelector('.goss-cbanner__clear').addEventListener('click', function () {
        window.GossVehicle.clear();
      });
    } else {
      el.innerHTML =
        '<div class="goss-cbanner"><span class="goss-cbanner__text">' +
        'Your truck is <strong>' + window.GossVehicle.label() + '</strong></span>' +
        '<a class="goss-cbanner__link" href="' + encodeURI(v.url || '/') + '">See parts that fit &rarr;</a></div>';
    }
  }

  function renderAll() {
    renderChip();
    renderFitBadge();
    renderCollectionBanner();
  }

  document.addEventListener(EVT, renderAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderAll);
  } else {
    renderAll();
  }
})();
